module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"firstnamePlaceholder":"Adınızı girin","lastnamePlaceholder":"Soyadınızı girin","emailPlaceholder":"Email adresinizi girin","passwordPlaceholder":"Şifrenizi girin","signupButton":"Üye Ol"},"en":{"firstnamePlaceholder":"Enter your firstname","lastnamePlaceholder":"Enter your lastname","emailPlaceholder":"Enter your email","passwordPlaceholder":"Enter your password","signupButton":"Sign Up"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/views/Signup.vue
// module id = nixg
// module chunks = 1